type Props = {
  size?: number;
  color?: string;
};

export const IconMinimize: React.FC<Props> = ({
  size = 20,
  color = "#fff",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5041 5.71108C10.2389 5.71108 9.98452 5.81643 9.79698 6.00397C9.60945 6.19151 9.50409 6.44586 9.50409 6.71108V8.30108L3.71409 2.50108C3.52578 2.31277 3.27039 2.20699 3.00409 2.20699C2.73779 2.20699 2.48239 2.31277 2.29409 2.50108C2.10579 2.68938 2 2.94478 2 3.21108C2 3.47738 2.10579 3.73277 2.29409 3.92108L8.09409 9.71108H6.50409C6.23887 9.71108 5.98452 9.81643 5.79698 10.004C5.60945 10.1915 5.50409 10.4459 5.50409 10.7111C5.50409 10.9763 5.60945 11.2307 5.79698 11.4182C5.98452 11.6057 6.23887 11.7111 6.50409 11.7111H10.5041C10.6348 11.7095 10.7639 11.6823 10.8841 11.6311C11.1284 11.5296 11.3226 11.3354 11.4241 11.0911C11.4753 10.9709 11.5025 10.8418 11.5041 10.7111V6.71108C11.5041 6.44586 11.3987 6.19151 11.2112 6.00397C11.0237 5.81643 10.7693 5.71108 10.5041 5.71108Z"
        fill={color}
      />
      <path
        d="M17.6142 14.584H16.0242L21.8242 20.374C21.9179 20.467 21.9923 20.5776 22.0431 20.6994C22.0938 20.8213 22.12 20.952 22.12 21.084C22.12 21.216 22.0938 21.3467 22.0431 21.4686C21.9923 21.5904 21.9179 21.701 21.8242 21.794C21.7312 21.8877 21.6206 21.9621 21.4988 22.0129C21.3769 22.0636 21.2462 22.0898 21.1142 22.0898C20.9822 22.0898 20.8515 22.0636 20.7296 22.0129C20.6078 21.9621 20.4972 21.8877 20.4042 21.794L14.6142 15.994V17.584C14.6142 17.8492 14.5088 18.1036 14.3213 18.2911C14.1338 18.4786 13.8794 18.584 13.6142 18.584C13.349 18.584 13.0946 18.4786 12.9071 18.2911C12.7195 18.1036 12.6142 17.8492 12.6142 17.584V13.584C12.6158 13.4533 12.6429 13.3242 12.6942 13.204C12.7957 12.9596 12.9898 12.7655 13.2342 12.664C13.3544 12.6127 13.4835 12.5856 13.6142 12.584H17.6142C17.8794 12.584 18.1338 12.6893 18.3213 12.8769C18.5088 13.0644 18.6142 13.3188 18.6142 13.584C18.6142 13.8492 18.5088 14.1036 18.3213 14.2911C18.1338 14.4786 17.8794 14.584 17.6142 14.584Z"
        fill={color}
      />
    </svg>
  );
};
